import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';

import { MessagesModule }         from '../../app-lite/messages/messages.module';
import { SharedModule }           from '../../app-lite/shared/shared.module';
import { TwoFactorAuthComponent } from './two-factor-auth.component';
import { TwoFactorAuthStates }    from './two-factor-auth.states';

@NgModule({
  declarations: [
    TwoFactorAuthComponent
  ],
  entryComponents: [
    TwoFactorAuthComponent
  ],
  imports: [
    MessagesModule,
    SharedModule,

    UIRouterModule.forChild({ states: TwoFactorAuthStates })
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class TwoFactorAuthModule {}
